import { getCookie } from './getCookie';

// NOTE: Set by the HubSpot tracking script. Frequently absent (ad blockers,
// incognito, script not loaded yet), which is expected: sign-up must not
// depend on it.
export const getHubspotUserToken = (): string | undefined =>
  getCookie('hubspotutk');
